// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bQQe","content":"styles_content__1MsHE"};